export default __webpack_public_path__ + "static/media/blog6.a4eba87e.jpg";